import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {DirectusService, EvaluationSubCriteriaDirectus} from '@frontend/directus';
import {
  EvaluationSubCriteriaControllerService,
  EvaluationSubCriteriaView,
  UpsertSubCriteriaRequest,
} from '@frontend/shared-api';
import {CriteriaConfig, SubCriteriaItem} from '../model/sub-criteria.interfaces';

@Injectable({providedIn: 'root'})
export class SubCriteriaEvaluationService {
  private readonly directus = inject(DirectusService);
  private readonly subCriteriaApi = inject(EvaluationSubCriteriaControllerService);

  loadSubCriteriaForEvaluation(
    _projectId: number,
    configs: CriteriaConfig[],
  ): Observable<Record<number, SubCriteriaItem[]>> {
    return this.directus.loadSubCriteria().pipe(
      map((allSubCriteria) => {
        const directusById = new Map(allSubCriteria.map((item) => [item.id, item]));
        const result: Record<number, SubCriteriaItem[]> = {};

        configs.forEach((cfg) => {
          result[cfg.evaluationCriteriaId] = this.toItems(
            cfg.criteriaData?.subCriteria ?? [],
            directusById,
          );
        });

        return result;
      }),
    );
  }

  saveSubCriteriaEvaluations(
    projectId: number,
    criteriaNumber: number,
    upsert: UpsertSubCriteriaRequest,
  ) {
    return this.subCriteriaApi.upsertEvaluationSubCriteria({
      projectId,
      evaluationCriteriaNumber: criteriaNumber,
      upsertSubCriteriaRequest: upsert,
    });
  }

  private toItems(
    existing: EvaluationSubCriteriaView[],
    directusById: Map<string, EvaluationSubCriteriaDirectus>,
  ): SubCriteriaItem[] {
    return existing.map((prev) => {
      const directus = directusById.get(prev.directusId);
      return {
        id: prev?.id,
        directusId: prev.directusId,
        translations: directus?.translations ?? [],
        included: prev?.included,
        scNumber: prev.scNumber,
        isSaving: false,
      };
    });
  }
}
